(ns manage.content-configuration-page.view.slide
  (:require [common.ui.slide :as ui.slide]
            [manage.content-configuration-page.view.add-item
             :refer
             [with-input-validation]]
            [manage.content-configuration-page.view.list
             :refer
             [published-cfg-read-only]]))

(defn view [cfg]
  [ui.slide/view
   (cond-> (published-cfg-read-only cfg)
     (map? (:list/add-item-cfg cfg))
     (update :list/add-item-cfg with-input-validation))])
